// @ts-nocheck
import { Component } from '@theme/component';
import { sectionRenderer } from '@theme/section-renderer';
import { ThemeEvents } from '@theme/events';
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('submit', function (e) {
    const formComponent = e.target.closest('product-form-component');
    if (formComponent) {
      if (performance.getEntriesByName('cart-performance:add:user-action:start').length === 0) {
        performance.mark('cart-performance:add:user-action:start');
      }
    }
  }, true);
});
class QuickViewModal extends Component {
  constructor() {
    super();
    this.modal = null;
    this.modalBody = null;
    this.mainSwiper = null;
    this.thumbsSwiper = null;
  }

  connectedCallback() {
    this.innerHTML = `
      <div id="quick-view-modal" class="quick-view-modal" data-quick-view="">
        <div class="quick-view-modal-content">
          <div class="modal-close-btn" id="quick-view-modal-close">
          <span class="visually-hidden">Close</span>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L2 12" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M12 12L2 2" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          </div>
          <div id="quick-view-modal-body" class="quick-view-body" data-url=""></div>
        </div>
      </div>
    `;

    this.modal = this.querySelector('#quick-view-modal');
    this.modalBody = this.querySelector('#quick-view-modal-body');
    const closeBtn = this.querySelector('#quick-view-modal-close svg');

    closeBtn.addEventListener('click', () => this.close());
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) this.close();
    });
    
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.quick-view__button--choose');
      if (btn) this.handleTriggerClick(e, btn);
    });
  }

  async handleTriggerClick(e, btn) {
    e.preventDefault();
    e.stopPropagation();
    const productHandle = btn.getAttribute('data-product-handle');
    if (!productHandle) {
      console.error('Quick View: missing data-product-handle');
      return;
    }
    const productId = btn.getAttribute('data-product-id'); 
    if (productId) {
      this.modal.setAttribute("data-quick-view", productId);
    }
    this.open();
    this.modalBody.innerHTML = '<div style="margin:auto;">Loading...</div>';

    try {
      const sectionUrl = new URL(`/products/${productHandle}`, window.location.origin);

      sectionUrl.searchParams.set('section_id', 'quick-view');
      const html = await sectionRenderer.getSectionHTML('quick-view', false, sectionUrl);

      if (html) {
        const parsedDoc = new DOMParser().parseFromString(html, 'text/html');
        const content = parsedDoc.querySelector('.quick-view-rendered-content');
        this.modalBody.innerHTML = content ? content.innerHTML : 'Product not found';

        if (window.customElements && window.customElements.upgrade) {
          const upgradeDescendants = (root) => {
            root.childNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                window.customElements.upgrade(node);
                upgradeDescendants(node);
              }
            });
          };
          upgradeDescendants(this.modalBody);
        }

        requestAnimationFrame(() => this.initSwipers());

        this.initializeModalWishlist();
      } else {
        this.modalBody.innerHTML = '<p style="margin:auto;">Product not found.</p>';
      }
    } catch (error) {
      console.error('QuickView Fetch Error:', error);
      this.modalBody.innerHTML = '<p style="margin:auto;">Error loading content.</p>';
    }
  }

  initializeModalWishlist() {
    if (window.SwymCallbacks) {
      window.SwymCallbacks.push((swat) => {
        swat.initializeActionButtons('#quick-view-modal-body');
        if (typeof swat.refreshWishlistButtons === 'function') {
          swat.refreshWishlistButtons();
        }
        document.addEventListener("swym:collections:refresh", () => {
          swat.initializeActionButtons(".product-grid, .collection-product-list, .product-recommendations");
        });
      });
    }
  }

  open() {
    this.modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  close() {
    const productId = this.modal.getAttribute("data-quick-view");
    this.modal.setAttribute("data-quick-view", "");
    this.modal.classList.remove('open');
    document.body.style.overflow = '';
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  }
  initSwipers() {
    const thumbSlides = this.querySelectorAll('.qv-thumbs-swiper .swiper-slide');
    if (thumbSlides.length === 0) return;
    const showArrows = thumbSlides.length > 4;
    const thumbPrev = this.querySelector('.thumb-prev');
    const thumbNext = this.querySelector('.thumb-next');
    if (thumbPrev) thumbPrev.style.display = showArrows ? 'flex' : 'none';
    if (thumbNext) thumbNext.style.display = showArrows ? 'flex' : 'none';
    this.thumbsSwiper = new Swiper(this.querySelector('.qv-thumbs-swiper'), {
      direction: 'vertical',
      slidesPerView: 'auto',
      spaceBetween: 10,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      observer: true,
      observeParents: true,
    });
    this.mainSwiper = new Swiper(this.querySelector('.qv-main-swiper'), {
      spaceBetween: 0,
      loop: true,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: '.mobile-next',
        prevEl: '.mobile-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        type: 'bullets',
      },
      thumbs: { swiper: this.thumbsSwiper },
    });
    if (thumbPrev) {
      thumbPrev.onclick = (e) => {
        e.preventDefault();
        this.mainSwiper.slidePrev();
      };
    }
    if (thumbNext) {
      thumbNext.onclick = (e) => {
        e.preventDefault();
        this.mainSwiper.slideNext();
      };
    }
  }
}
customElements.define('quick-view-modal', QuickViewModal);

class ProductEventModal extends Component {
  constructor() {
    super();
    this.modal = this.querySelector('.modal-overlay');
    this.closeBtn = this.querySelector('.close-btn');
    this.tabBtns = this.querySelectorAll('.tab-btn');
    this.tabContents = this.querySelectorAll('.tab-content');

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.resetModal = this.resetModal.bind(this);
  }

  connectedCallback() {
    this.closeBtn.addEventListener('click', this.closeModal);
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) this.closeModal();
    });

    this.tabBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => this.switchTab(e));
    });

    this.querySelectorAll('.cal-btn').forEach((btn) => {
      btn.addEventListener('click', (e) => this.handleCalendarClick(e));
    });

    this.querySelector('.submit-email-btn').addEventListener('click', () => this.handleEmailSubmit());
    this.querySelector('.submit-sms-btn').addEventListener('click', () => this.handleSmsSubmit());

    const phoneInput = this.querySelector('.phone-input');
    if (phoneInput)
      phoneInput.addEventListener('input', (e) => (e.target.value = e.target.value.replace(/[^0-9]/g, '')));

    document.body.addEventListener('click', (e) => {
      const calendarTrigger = e.target.closest('.calendar-event');
      if (calendarTrigger) {
        e.preventDefault();
        e.stopPropagation();
        this.openModal(calendarTrigger);
        const closeDrawer = document.querySelector('.cart-items-component button[ref="closeButton"]');
        if (closeDrawer) {
          closeDrawer.click();
        }
      }
    });
  }

  openModal(trigger) {
    // 1. Fill Data
    const d = {
      id: trigger.dataset.id,
      title: trigger.dataset.title,
      start: trigger.dataset.start,
      end: trigger.dataset.end,
      desc: trigger.dataset.description || `Event for ${trigger.dataset.title}`,
      loc: trigger.dataset.address,
    };

    // Helper to set value and attribute (for DOM clarity)
    const setVal = (name, val) => {
      const el = this.querySelector(`[name="${name}"]`);
      if (el) {
        el.value = val;
        el.setAttribute('value', val);
      }
    };

    setVal('product-id', d.id);
    setVal('product-title', d.title);
    setVal('event-start', d.start);
    setVal('event-end', d.end);
    setVal('event-desc', d.desc);
    setVal('event-location', d.loc);

    const nameDisplay = this.querySelector('.dynamic-product-name');
    if (nameDisplay) nameDisplay.textContent = d.title;

    // 2. Show Modal
    document.body.style.overflow = 'hidden';
    this.modal.classList.add('open');
  }

  closeModal() {
    document.body.style.overflow = '';
    this.modal.classList.remove('open');
    // Wait for animation to finish, then wipe data
    setTimeout(() => {
      this.resetModal();
    }, 300);
  }

  resetModal() {
    // 1. Clear ALL Inputs (Hidden + Visible)
    this.querySelectorAll('input').forEach((input) => {
      if (input.type === 'checkbox') {
        input.checked = false;
      } else {
        input.value = '';
        input.setAttribute('value', '');
      }
      input.classList.remove('input-error');
    });

    // 2. Clear Dynamic Text
    const nameDisplay = this.querySelector('.dynamic-product-name');
    if (nameDisplay) nameDisplay.textContent = 'this product';

    // 3. Reset Tabs to First Tab
    this.tabBtns.forEach((t) => t.classList.remove('active'));
    this.tabContents.forEach((c) => c.classList.remove('active-content'));

    if (this.tabBtns[0]) {
      this.tabBtns[0].classList.add('active');
      const content = this.querySelector(`.tab-content[data-content="${this.tabBtns[0].dataset.tab}"]`);
      if (content) content.classList.add('active-content');

      // Reset Title to default
      const titleEl = this.querySelector('.modal-title');
      if (titleEl) titleEl.textContent = this.tabBtns[0].dataset.title;
    }

    // 4. Reset Styles
    this.querySelectorAll('.error-msg').forEach((el) => (el.style.display = 'none'));
    this.querySelectorAll('.sms-input-group').forEach((el) => (el.style.borderColor = '#ddd'));
  }

  switchTab(e) {
    const btn = e.target;
    this.tabBtns.forEach((b) => b.classList.remove('active'));
    this.tabContents.forEach((c) => c.classList.remove('active-content'));

    btn.classList.add('active');
    const content = this.querySelector(`.tab-content[data-content="${btn.dataset.tab}"]`);
    if (content) content.classList.add('active-content');

    const titleEl = this.querySelector('.modal-title');
    if (titleEl) titleEl.textContent = btn.dataset.title;
  }

  handleCalendarClick(e) {
    const provider = e.currentTarget.dataset.provider;
    const sVal = this.querySelector('[name="event-start"]').value;
    const eVal = this.querySelector('[name="event-end"]').value;
    const sDate = sVal ? new Date(sVal) : new Date(Date.now() + 86400000);
    const eDate = eVal ? new Date(eVal) : new Date(Date.now() + 90000000);

    const evt = {
      title: this.querySelector('[name="product-title"]').value,
      desc: this.querySelector('[name="event-desc"]').value,
      loc: this.querySelector('[name="event-location"]').value,
      start: sDate,
      end: eDate,
    };

    const fmt = (d) => d.toISOString().replace(/-|:|\.\d\d\d/g, '');

    if (provider === 'google') {
      window.open(
        `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
          evt.title
        )}&dates=${fmt(evt.start)}/${fmt(evt.end)}&details=${encodeURIComponent(
          evt.desc
        )}&location=${encodeURIComponent(evt.loc)}`,
        '_blank'
      );
    } else if (provider === 'outlook') {
      window.open(
        `https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent&startdt=${evt.start.toISOString()}&enddt=${evt.end.toISOString()}&subject=${encodeURIComponent(
          evt.title
        )}&body=${encodeURIComponent(evt.desc)}&location=${encodeURIComponent(evt.loc)}`,
        '_blank'
      );
    } else {
      const ics = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'BEGIN:VEVENT',
        `URL:${evt.loc}`,
        `DTSTART:${fmt(evt.start)}`,
        `DTEND:${fmt(evt.end)}`,
        `SUMMARY:${evt.title}`,
        `DESCRIPTION:${evt.desc}`,
        `LOCATION:${evt.loc}`,
        'END:VEVENT',
        'END:VCALENDAR',
      ].join('\n');
      const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${evt.title.replace(/[^a-z0-9]/gi, '_')}.ics`;
      link.click();
    }
  }

  handleEmailSubmit() {
    const input = this.querySelector('.email-input');
    const error = this.querySelector('.email-error');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value)) {
      input.classList.add('input-error');
      error.style.display = 'block';
    } else {
      alert('Email Registered: ' + input.value);
      this.closeModal();
    }
  }

  handleSmsSubmit() {
    const input = this.querySelector('.phone-input');
    const group = this.querySelector('.sms-input-group');
    const error = this.querySelector('.phone-error');
    if (input.value.length < 10) {
      group.style.borderColor = 'red';
      error.style.display = 'block';
    } else {
      alert('SMS Sent');
      this.closeModal();
    }
  }
}
customElements.define('product-event-modal', ProductEventModal);

class LocationEventModal extends Component {
  constructor() {
    super();
    this.render();
    this.modal = this.querySelector('.location-modal-popup');
    this.closeBtn = this.querySelector('.close-btn');
    this.imgEl = this.querySelector('.locationImage');
    this.addressEl = this.querySelector('.locationAddress');
    this.phoneEl = this.querySelector('.locationPhone');
    this.iframeEl = this.querySelector('.location-ifreme-container');
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  connectedCallback() {
    this.closeBtn.addEventListener('click', this.closeModal);
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) this.closeModal();
    });
    document.body.addEventListener('click', (e) => {
      const trigger = e.target.closest('.event-location-trigger');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        this.openModal(trigger);
      }
    });
  }

  openModal(trigger) {
    try {
      const rawData = trigger.dataset.locationDetails;
      const imageUrl = trigger.dataset.locationImage;

      if (!rawData) return;

      const data = JSON.parse(rawData);
      this.imgEl.src = imageUrl || '';
      this.addressEl.textContent = data.address || '';
      this.phoneEl.textContent = data.contact_no || '';
      if (data.location_iframe) {
        this.iframeEl.innerHTML = data.location_iframe;
      } else {
        this.iframeEl.innerHTML = '';
      }
      this.modal.style.display = 'flex';
    } catch (err) {
      console.error('Invalid Location JSON', err);
    }
  }

  closeModal() {
    this.modal.style.display = 'none';
    this.iframeEl.innerHTML = '';
    this.imgEl.src = '';
    this.addressEl.textContent = '';
    this.phoneEl.textContent = '';
  }

  render() {
    this.innerHTML = `
    <div class="location-modal-popup">
      <div class="location-modal-content">
        <button type="button" class="close-btn" aria-label="Close">&times;</button>

        <div class="event-location-popup">
          <div class="event-location-image">
            <img class="locationImage" src="" alt="Location Image">
          </div>

          <div class="event-location-info">
            <p class="event-address">
              <span class="event-heading">Address: </span>
              <span class="locationAddress"></span>
            </p>
            <p class="event-phone">
              <span class="event-heading">Phone: </span>
              <span class="locationPhone"></span>
            </p>
            <div class="location-ifreme-container"></div>
          </div>
        </div>
      </div>
    </div>
  `;
  }
}
customElements.define('location-event-modal', LocationEventModal);

class StickyAtc extends Component {
  constructor() {
    super();
    this.footer = document.querySelector(this.dataset.footerSelector);
    this.mainAtcContainer = document.querySelector('.product-information__grid .product-form-buttons add-to-cart-component[ref="addToCartButtonContainer"]');
    this.mainBuyButtons = document.querySelector('.product-information__grid .buy-buttons-block');
    this.contentArea = this.querySelector('.sticky-atc-right-content');
  }

  connectedCallback() {
    if (!this.mainAtcContainer || !this.mainBuyButtons) return;

    this.initButtons();
    this.initObservers();
    window.addEventListener('resize', () => this.applyFooterMargin());
  }

  initButtons() {
    this.contentArea.innerHTML = this.mainBuyButtons.innerHTML;
    if (window.matchMedia('(min-width: 769px)').matches) {
      const stickyQty = this.contentArea.querySelector('.quantity-selector');
      const desktopPrice = this.querySelector('.desktop-price-ref');
      if (stickyQty && desktopPrice) {
        stickyQty.insertAdjacentElement('afterend', desktopPrice);
      }
    }
  }

  initObservers() {
    const stickyObserver = new IntersectionObserver(
      (entries) => {
        this.classList.toggle('is-visible', !entries[0].isIntersecting);
        if (!entries[0].isIntersecting) this.applyFooterMargin();
      },
      { threshold: 0 }
    );
    stickyObserver.observe(this.mainAtcContainer);
    if (this.footer) {
      const footerObserver = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) this.applyFooterMargin();
        },
        { rootMargin: '100px' }
      );
      footerObserver.observe(this.footer);
    }
  }
  applyFooterMargin() {
    if (this.classList.contains('is-visible') && this.footer) {
      const atcHeight = this.offsetHeight;
      this.footer.style.transition = 'margin-bottom 0.3s ease';
      this.footer.style.marginBottom = `${atcHeight}px`;
    } else if (this.footer) {
      this.footer.style.marginBottom = '0px';
    }
  }
}
customElements.define('sticky-atc', StickyAtc);

const initCategorySwiper = () => {
  const containers = document.querySelectorAll('.category-values:not(.is-initialized)');
  containers.forEach(container => {
    const slider = container.querySelector('.category-slider');
    if (!slider || typeof Swiper === 'undefined') return;
    const slideCount = parseInt(container.dataset.slideCount) || 0;
    new Swiper(slider, {
      slidesPerView: 3.5,
      spaceBetween: 6,
      centeredSlides: false,
      centerInsufficientSlides: true,
      loop: slideCount > 10,
      speed: 800,
      watchOverflow: true,
      grabCursor: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
      },
      navigation: {
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        768: { slidesPerView: 5, spaceBetween: 0 },
        1024: { slidesPerView: 8, spaceBetween: 0 },
        1440: { slidesPerView: 10, spaceBetween: 0 },
      },
      on: {
        init: () => container.classList.add('is-initialized'),
      }
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCategorySwiper);
} else {
  initCategorySwiper();
}
document.addEventListener('facet:updated', initCategorySwiper);
document.addEventListener('DOMContentLoaded', function () {
  initTabs();
});

// --- PDP multi tabs Logic ---
function initTabs() {
  const tabsContainer = document.querySelector('.pdp-multitabs');
  if (!tabsContainer) return;

  tabsContainer.addEventListener('click', function (e) {
    const clickedTab = e.target.closest('.tab');
    if (!clickedTab || clickedTab.classList.contains('active')) return;

    const tabClass = Array.from(clickedTab.classList).find(c => c.startsWith('tab-') && c !== 'tab');
    if (!tabClass) return;

    const targetId = tabClass.split('-')[1];
    const currentActiveTab = tabsContainer.querySelector('.tab.active');
    const currentActiveContent = tabsContainer.querySelector('.content-container.active');

    if (currentActiveTab) currentActiveTab.classList.remove('active');
    if (currentActiveContent) currentActiveContent.classList.remove('active');

    clickedTab.classList.add('active');
    const targetContent = tabsContainer.querySelector('.content-container-' + targetId);
    if (targetContent) targetContent.classList.add('active');
  });
}

class ImageWithText extends Component {
  constructor() {
    super();
    this.swiper = null;
    this._onResize = null;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    if (this._onResize) {
      window.removeEventListener('resize', this._onResize);
      this._onResize = null;
    }
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  init() {
    const swiperEl = this.querySelector('.image-with-text__swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;
    if (swiperEl.dataset.swiperInit === 'true') return;

    const paginationEl = this.querySelector('.swiper-pagination');
    let config = {};
    try {
      config = JSON.parse(this.getAttribute('data-carousel-config') || '{}');
    } catch (e) {
      console.error('Image with text: invalid config JSON', e);
    }

    config.pagination = {
      el: paginationEl,
      clickable: true,
    };
    config.on = {
      init: function () {
        ImageWithText.togglePagination(this, paginationEl);
      },
      update: function () {
        ImageWithText.togglePagination(this, paginationEl);
      },
    };

    this.swiper = new Swiper(swiperEl, config);
    swiperEl.dataset.swiperInit = 'true';

    this._onResize = () => this.swiper?.update();
    window.addEventListener('resize', this._onResize);
  }

  static togglePagination(swiper, el) {
    if (!el) return;
    const isEnoughSlides = swiper.slides.length > swiper.params.slidesPerView;
    el.style.display = isEnoughSlides ? 'block' : 'none';
    swiper.el.classList.toggle('image-with-text__swiper--paginated', isEnoughSlides);
  }
}

if (!customElements.get('image-with-text')) {
  customElements.define('image-with-text', ImageWithText);
}

class HeroSlideshow extends Component {
  constructor() {
    super();
    this.swiper = null;
  }
  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  }
  init() {
    const swiperEl = this.querySelector('.hero-slideshow__swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;
    if (swiperEl.dataset.swiperInit === 'true') return;
    let config = {};
    try {
      config = JSON.parse(this.getAttribute('data-carousel-config') || '{}');
    } catch (e) {
      console.error('Hero Slideshow: invalid config JSON', e);
    }
    config.navigation = {
      nextEl: this.querySelector('.swiper-button-next'),
      prevEl: this.querySelector('.swiper-button-prev')
    };
    config.pagination = {
      el: this.querySelector('.swiper-pagination'),
      clickable: true
    };
    this.swiper = new Swiper(swiperEl, config);
    swiperEl.dataset.swiperInit = 'true';
  }
}
if (!customElements.get('hero-slideshow')) {
  customElements.define('hero-slideshow', HeroSlideshow);
}

(function () {
  const section = document.querySelector('product-swiper#product-recently-viewed');
  if (!section) return;

  const intent = section.dataset.intent;
  const lazySentinel = document.getElementById('product-recently-viewed-sentinel');

  /**
   * From `data-limit` on product-carousel (`max_products`).
   * If missing/invalid: 20 (previous hardcoded slice); valid values clamped to 1–20.
   */
  function getRecentlyViewedSliceLimit() {
    const n = parseInt(section.dataset.limit, 10);
    if (!Number.isFinite(n) || n < 1) return 20;
    return Math.min(n, 20);
  }

  /**
   * Page-based dots (matches “products per view”): desktop and mobile sets like resource-list-carousel.
   * No ref="dots[]" — theme would sync aria-selected to slide index; we sync to page in bindRecentlyViewedPageDotSync.
   */
  function buildRecentlyViewedSlideshowControls(slideCount, desktopCols, mobileCols) {
    const openTag =
      '<slideshow-controls ref="slideshowControls" pagination-position="center" scroll-mode="horizontal"';
    if (slideCount <= 1) {
      return openTag + ' class="dots-hidden"></slideshow-controls>';
    }
    const dc = Math.max(1, desktopCols);
    const mc = Math.max(1, mobileCols);
    const desktopPages = Math.max(1, Math.ceil(slideCount / dc));
    const mobilePages = Math.max(1, Math.ceil(slideCount / mc));

    const desktopLis = [];
    for (let p = 0; p < desktopPages; p++) {
      const start = Math.min(p * dc, slideCount - 1);
      const timeline = start + 1;
      desktopLis.push(
        '<li class="rv-page-dot-desktop"><button type="button" class="slideshow-control button button-unstyled recently-viewed-page-dot" style="animation-timeline: --slide-' +
          timeline +
          '" aria-label="Page ' +
          (p + 1) +
          ' of ' +
          desktopPages +
          '" on:click="/select/' +
          start +
          '">' +
          (p + 1) +
          '</button></li>'
      );
    }

    const mobileLis = [];
    for (let p = 0; p < mobilePages; p++) {
      const start = Math.min(p * mc, slideCount - 1);
      const timeline = start + 1;
      mobileLis.push(
        '<li class="rv-page-dot-mobile mobile-dots"><button type="button" class="slideshow-control button button-unstyled recently-viewed-page-dot" style="animation-timeline: --slide-' +
          timeline +
          '" aria-label="Page ' +
          (p + 1) +
          ' of ' +
          mobilePages +
          '" on:click="/select/' +
          start +
          '">' +
          (p + 1) +
          '</button></li>'
      );
    }

    return (
      openTag +
      ' class="dots-on-mobile-desktop"><ol class="slideshow-controls__dots rv-recently-viewed-page-dots" item-count="' +
      desktopPages +
      '">' +
      desktopLis.join('') +
      mobileLis.join('') +
      '</ol></slideshow-controls>'
    );
  }

  function bindRecentlyViewedPageDotSync(container) {
    const slideshow = container.querySelector('slideshow-component');
    if (!slideshow) return;

    const desktopCols = Math.max(1, parseInt(String(section.dataset.columns || '4'), 10) || 4);
    const mobileCols = Math.max(1, parseInt(String(section.dataset.mobileColumns || '2'), 10) || 2);

    const slideCount = () => container.querySelectorAll('slideshow-slide').length;

    const sync = () => {
      const n = slideCount();
      if (n <= 1) return;

      let index = 0;
      if (typeof slideshow.current === 'number' && !Number.isNaN(slideshow.current)) {
        index = slideshow.current;
      }

      const wide = window.matchMedia('(min-width: 769px)').matches;
      const cols = wide ? desktopCols : mobileCols;
      const pages = Math.max(1, Math.ceil(n / cols));
      const page = Math.min(Math.max(0, Math.floor(index / cols)), pages - 1);

      const sel = wide
        ? '.rv-page-dot-desktop .recently-viewed-page-dot'
        : '.rv-page-dot-mobile .recently-viewed-page-dot';
      container.querySelectorAll(sel).forEach((btn, i) => {
        btn.setAttribute('aria-selected', String(i === page));
      });
    };

    slideshow.addEventListener('slideshow:select', sync);
    let resizeT = 0;
    window.addEventListener('resize', function onRvResize() {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () {
        requestAnimationFrame(sync);
      }, 150);
    });
    requestAnimationFrame(sync);
    requestAnimationFrame(sync);
  }

  /**
   * Product card HTML already includes Swym wishlist (wishlist-button). Slideshow slides use
   * content-visibility: hidden for non-active slides — overridden in product-carousel CSS for
   * #product-recently-viewed so all cards can be initialized.
   */
  function initRecentlyViewedSwymButtons() {
    const rootSelector = '#product-recently-viewed';
    const run = (swat) => {
      if (!swat || typeof swat.initializeActionButtons !== 'function') return;
      try {
        swat.initializeActionButtons(rootSelector);
        if (typeof swat.refreshWishlistButtons === 'function') {
          swat.refreshWishlistButtons();
        }
      } catch (e) {
        console.warn('RecentlyViewed: Swym initializeActionButtons failed', e);
      }
    };

    if (typeof window._swat !== 'undefined' && window._swat) {
      run(window._swat);
      return;
    }
    if (window.SwymCallbacks && Array.isArray(window.SwymCallbacks)) {
      window.SwymCallbacks.push(run);
    }
  }

  async function handleRecentlyViewed() {
    if (intent !== 'recently-viewed') return;

    const currentProductId = section.dataset.productId;
    const sliceLimit = getRecentlyViewedSliceLimit();
    const storageKey = 'recently_viewed_products';
    let items = [];

    try {
      items = JSON.parse(localStorage.getItem(storageKey) || '[]');
    } catch (err) {
      console.warn('RecentlyViewed: localStorage access denied', err);
    }
    const filteredItems = items.filter((id) => id !== currentProductId);

    if (filteredItems.length === 0) {
      section.style.display = 'none';
      return;
    }

    const container = section.querySelector('.resource-list');
    if (!container) {
      console.warn('RecentlyViewed: missing .resource-list');
      return;
    }

    section.setAttribute('data-recently-viewed-loading', '');

    const queryString = filteredItems
      .slice(0, sliceLimit)
      .map((id) => `id:${id}`)
      .join(' OR ');

    const searchUrl = new URL(window.Shopify.routes.root + 'search', window.location.origin);
    searchUrl.searchParams.set('q', queryString);
    searchUrl.searchParams.set('type', 'product');

    const desktopCols = Math.max(1, parseInt(String(section.dataset.columns || '4'), 10) || 4);
    const mobileCols = Math.max(1, parseInt(String(section.dataset.mobileColumns || '2'), 10) || 2);
    const visibleSlideCount = desktopCols;

    try {
      const res = await fetch(searchUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!res.ok) throw new Error(`Search returned ${res.status}`);
      const html = await res.text();

      if (html && container) {
        const parsedDoc = new DOMParser().parseFromString(html, 'text/html');
        const fetchedItems = parsedDoc.querySelectorAll('.product-grid__item');

        if (fetchedItems.length > 0) {
          let slidesHTML = '';

          fetchedItems.forEach((item, index) => {
            const slideIndex = index + 1;

            slidesHTML += `
                <slideshow-slide 
                  ref="slides[]" 
                  aria-hidden="${index >= visibleSlideCount ? 'true' : 'false'}" 
                  style="view-timeline-name: --slide-${slideIndex}; --product-media-fit: cover;" 
                  class="resource-list__slide"
                >
                  <div class="resource-list__item">
                    ${item.innerHTML}
                  </div>
                </slideshow-slide>`;
          });

          const carouselContent = `
              <div class="resource-list__carousel" style="--slide-width-max: 300px; --gutter-slide-width: var(--util-page-margin-offset);">
                <slideshow-component ref="resourceListCarousel" class="resource-list__carousel" initial-slide="0">
                  <slideshow-container ref="slideshowContainer">
                    <slideshow-arrows position="center"><button class="slideshow-control slideshow-control--previous slideshow-control--shape-circle slideshow-control--style-chevron button button-unstyled button-unstyled--transparent flip-x" aria-label="Previous slide" on:click="/previous" ref="previous">
                    <span class="svg-wrapper icon-caret"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 5.5L7 9.5L3 5.5" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                    </span>
                    </button>
                    <button class="slideshow-control slideshow-control--next slideshow-control--shape-circle slideshow-control--style-chevron button button-unstyled button-unstyled--transparent" aria-label="Next slide" on:click="/next" ref="next">
                    <span class="svg-wrapper icon-caret"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 5.5L7 9.5L3 5.5" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                    </span>
                    </button>
                    </slideshow-arrows>
                    <slideshow-slides tabindex="-1" ref="scroller" gutters="start end">
                      ${slidesHTML}
                    </slideshow-slides>
                  </slideshow-container>
                  ${buildRecentlyViewedSlideshowControls(fetchedItems.length, desktopCols, mobileCols)}
                </slideshow-component>
              </div>`;

          container.innerHTML = carouselContent;
          section.removeAttribute('data-recently-viewed-loading');
          section.style.display = 'block';
          if (window.customElements && window.customElements.upgrade) {
            window.customElements.upgrade(container);
          }
          bindRecentlyViewedPageDotSync(container);
          const runSwymAndResize = () => {
            initRecentlyViewedSwymButtons();
            window.dispatchEvent(new Event('resize'));
          };
          window.requestAnimationFrame(runSwymAndResize);
          window.setTimeout(runSwymAndResize, 350);
        } else {
          section.removeAttribute('data-recently-viewed-loading');
          section.style.display = 'none';
        }
      }
    } catch (error) {
      console.error('RecentlyViewed: Fetch error', error);
      section.removeAttribute('data-recently-viewed-loading');
      section.style.display = 'none';
    }
  }
  if ('IntersectionObserver' in window && lazySentinel) {
    const recentlyViewedObserver = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0]?.isIntersecting) return;
        observer.disconnect();
        lazySentinel.remove();
        handleRecentlyViewed();
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    recentlyViewedObserver.observe(lazySentinel);
  } else {
    lazySentinel?.remove();
    handleRecentlyViewed();
  }
})();

function swymCallbackFn(swat){
  try {
    if (typeof swat.initializeActionButtons === 'function') {
      swat.initializeActionButtons('.product-recommendations');
    }
    if (typeof swat.refreshWishlistButtons === 'function') {
      swat.refreshWishlistButtons();
    }
  } catch (e) {
    console.warn('Swym: product-recommendations wishlist bind', e);
  }
  document.addEventListener("facet:updated", function(){
    swat.collectionsApi.removeCollectionsButtons();
    swat.collectionsApi.initializeCollections(swat, true, window.Shopify.theme.schema_name);
  })
}
if(!window.SwymCallbacks){ window.SwymCallbacks = []; }
window.SwymCallbacks.push(swymCallbackFn);
